// Import assets from src/assets
import janeStreetLogo from "../assets/jane_street.png";
import citadelLogo from "../assets/citadel.png";
import gsLogo from "../assets/goldman_sachs.png";
import twoSigmaLogo from "../assets/two_sigma.png";
import deShawLogo from "../assets/de_shaw.png";
import hrtLogo from "../assets/hrt.jpeg";
import renTechLogo from "../assets/ren_tech.jpeg";
import citadelSecLogo from "../assets/citadel_securities.png";
import virtuLogo from "../assets/virtu.png";
import jumpLogo from "../assets/jump_trading.png";
import optiverLogo from "../assets/optiver.png";
import msLogo from "../assets/morgan_stanley.png";
import imcLogo from "../assets/imc.png";


export const PROBLEMS_PER_PAGE = 20;

export const TOPICS = [
  "All",
  "Probability",
  "Combinatorics",
  "Stochastic Calculus",
  "Linear Algebra",
  "Statistics",
  "Machine Learning",
  "Others",
  "Brain Teasers",
  "Market Microstructure",
];

export const DIFFICULTIES = ["All", "Easy", "Medium", "Hard", "Elite"];

export const COMPANY_META = {
  "Jane Street":              { bg: "#0a1628", color: "#fff", abbr: "JS",  logo: janeStreetLogo },
  Citadel:                    { bg: "#002366", color: "#fff", abbr: "CIT", logo: citadelLogo },
  "Goldman Sachs":            { bg: "#1a4a8a", color: "#fff", abbr: "GS",  logo: gsLogo },
  "Two Sigma":                { bg: "#1c1c1c", color: "#fff", abbr: "2Σ",  logo: twoSigmaLogo },
  "D.E. Shaw":                { bg: "#004225", color: "#fff", abbr: "DE",  logo: deShawLogo },
  "Hudson River Trading":     { bg: "#0f3460", color: "#fff", abbr: "HRT", logo: hrtLogo },
  "Renaissance Technologies": { bg: "#8b0000", color: "#fff", abbr: "REN", logo: renTechLogo },
  "Citadel Securities":       { bg: "#002366", color: "#fff", abbr: "CS",  logo: citadelSecLogo },
  Virtu:                      { bg: "#e25c00", color: "#fff", abbr: "VIR", logo: virtuLogo },
  "Jump Trading":             { bg: "#1a1a2e", color: "#fff", abbr: "JMP", logo: jumpLogo },
  Optiver:                    { bg: "#c0392b", color: "#fff", abbr: "OPT", logo: optiverLogo },
  "Morgan Stanley":           { bg: "#00457c", color: "#fff", abbr: "MS",  logo: msLogo },
  IMC:                         { bg: "#123b88", color: "#fff", abbr: "IMC", logo: imcLogo },
  Point72:                     { bg: "#2c3e50", color: "#fff", abbr: "P72", logo: null },
};

export const DIFFICULTY_META = {
  Easy:   { color: "#2d7a4f", bg: "#edf7f1", dot: "#2d7a4f" },
  Medium: { color: "#7a5c1e", bg: "#fdf6e8", dot: "#c98a1a" },
  Hard:   { color: "#8b2e2e", bg: "#fdf0f0", dot: "#c0392b" },
  Elite:  { color: "#3b1f7a", bg: "#f3f0fd", dot: "#6b4fe0" },
};
